import { vars } from "plos/src/styles/theme.css";
import { style } from "@vanilla-extract/css";

export const sheetContainer = style({
  display: "flex",
  flexDirection: "column",
  padding: vars.space.m,
  paddingTop: 0,
  height: "100%",
});

export const contentWrapper = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "100%",
});
